import React, { useState } from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
  Box,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  AddCircle,
  MoreVert,
  Edit,
  Delete,
  RemoveCircle,
} from "@mui/icons-material";
import {
  get_banner,
  add_shipping_charge,
  edit_shipping_charge,
  delete_shipping_charge,
  get_category,
  get_shipping_country,
  edit_shipping_country,
  get_upload_file,
  add_banner,
  edit_banner,
  delete_banner,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-simple-toasts";

export default function Banner() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const [sort, setSort] = React.useState(0);

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");
  const handleSearch = (event) => {
    setSearchKey(event.target.value);
  };

  const [loading, setLoading] = useState(false);
  const [totalList, setTotalList] = React.useState(1);
  const [pageNum, setPageNum] = React.useState(0);

  const [listData, setlistData] = React.useState(null);
  const [countryList, setCountryList] = React.useState(null);
  const [categoryList, setClassList] = React.useState(null);

  const [openAdd, setOpenAdd] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [selectedBanner, setSelectedBanner] = React.useState(null);
  const [addData, setAddData] = React.useState({
    title: "",
    subtitle: "",
    image: "",
    weight: "",
  });
  const [openEditCountry, setOpenEditCountry] = React.useState(false);
  const [countryData, setCountryData] = React.useState({
    shipping_country_id: "",
    default_shipping: "",
  });

  const getData = () => {
    setLoading(true);
    get_banner({
      //   page: pageNum + 1
      // sort: sort
    }).then((json) => {
      setLoading(false);
      setlistData(json.data);
      // setSelectedPage(json.data.page)
      //   setTotalList(json.total)
    });
  };

  React.useEffect(() => {
    getData();
  }, [pageNum, sort]);

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
    // getData();
  };

  const [disabled, setDisabled] = React.useState(false);

  const handleCaptureSingle = async (e, index) => {
    setDisabled(true);
    var formData = new FormData();
    // var token = window.localStorage.getItem("token");
    // formData.append("token", token);
    formData.append("image", e.target.files[0]);
    // setisLoading(true);
    var res = await get_upload_file(formData);

    // console.log(res);
    if (res.data.status) {
      setDisabled(false);
      setAddData({
        ...addData,
        image: res.data.data,
      });
    } else {
      setDisabled(false);
      toast(res.data.message);
    }
  };

  const handleOpenAdd = (e) => {
    setOpenAdd(true);
    setAddData({
      title: "",
      subtitle: "",
      image: "",
      weight: "",
    });
  };
  const handleCloseAdd = (value) => {
    setOpenAdd(false);
  };

  const handleChangeAdd = (e) => {
    setAddData({
      ...addData,
      [e.target.name]: e.target.value,
    });
  };

  const [choosePage, setChoosePage] = React.useState("0");

  const [selectedPage, setSelectedPage] = React.useState("");

  const handleChoosePage = (e) => {
    setChoosePage(e.target.value);
    setSelectedPage(e.target.value);
  };

  const handleAddBanner = () => {
    if (addData.image.length == 0) {
      toast("Please upload image");
      return;
    }

    if (choosePage == 0) {
      toast("Please choose a page");
      return;
    }

    if (choosePage == "Home") {
      if (addData.weight.length == 0) {
        toast("Please enter weight");
        return;
      }
    }

    // if (addData.title.length == 0) {
    //   toast("Please enter title");
    //   return;
    // }
    // if (addData.subtitle.length == 0) {
    //   toast("Please enter subtitle");
    //   return;
    // }
    setDisabled(true);

    let postparam = {
      ...addData,
      page: choosePage,
    };

    // console.log(postparam);

    add_banner(postparam).then((json) => {
      if (json.status) {
        setDisabled(false);
        toast("Banner Added");
        handleCloseAdd();
        getData();
        setAddData({
          title: "",
          subtitle: "",
          image: "",
          weight: "",
        });
      } else {
        setDisabled(false);
        toast(json.message);
      }
    });
  };

  const handleOpenEdit = (e) => {
    setOpenEdit(true);
    setAddData({
      title: e.title,
      subtitle: e.subtitle,
      image: e.image,
      weight: e.weight,
      banner_id: e.banner_id,
      page: e.page,
    });
  };
  const handleCloseEdit = (value) => {
    setOpenEdit(false);
  };

  const handleEditBanner = () => {
    if (addData.weight.length == 0) {
      toast("Please enter weight");
      return;
    }
    // if (addData.title.length == 0) {
    //   toast("Please enter title");
    //   return;
    // }
    // if (addData.subtitle.length == 0) {
    //   toast("Please enter subtitle");
    //   return;
    // }
    setDisabled(true);
    edit_banner({ ...addData, page: choosePage }).then((json) => {
      if (json.status) {
        setDisabled(false);
        toast("Banner Edited");
        handleCloseEdit();
        getData();
        setAddData({
          // title: "",
          // subtitle: "",
          // image: "",
          // weight: "",
        });

        setChoosePage(0);
      } else {
        setDisabled(false);
        toast(json.message);
      }
    });
  };

  const handleOpenDelete = (e) => {
    setOpenDelete(true);
    setSelectedBanner(e);
  };
  const handleCloseDelete = (value) => {
    setOpenDelete(false);
  };
  const handleDeleteBanner = () => {
    setLoading(true);
    delete_banner({ banner_id: selectedBanner }).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Banner Deleted");
        handleCloseDelete();
        getData();
      } else {
        setLoading(false);
        toast(json.message);
      }
    });
  };

  // const handleOpenEditCountry = (e) => {
  //   setOpenEditCountry(true);
  //   setCountryData({
  //     shipping_country_id: e.shipping_country_id,
  //     default_shipping: e.default_shipping,
  //   });
  // };
  // const handleCloseEditCountry = (value) => {
  //   setOpenEditCountry(false);
  // };

  // const handleEditCountry = () => {
  //   setLoading(true);
  //   edit_shipping_country(countryData).then((json) => {
  //     if (json.status) {
  //       setLoading(false);
  //       toast("Shipping Default Changed");
  //       handleCloseEditCountry();
  //       getData();
  //       setCountryData({
  //         shipping_country_id: "",
  //         default_shipping: "",
  //       });
  //     } else {
  //       setLoading(false);
  //       toast(json.message);
  //     }
  //   });
  // };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <Navbar2
          children={
            <Section pd="2rem">
              <div>
                <div className={classes.theFlexHeader}>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Banner
                  </Paragraph>

                  <div
                    className={classes.theFlexBtn}
                    style={{ marginBottom: "0" }}
                  >
                    <a
                      className={classes.theCustomActionBtn_}
                      onClick={() => handleOpenAdd()}
                    >
                      <AddCircle sx={{ color: "#1A5386" }} />
                      <Paragraph color="#1A5386" margin="0 0 0 .4rem">
                        Add Banner
                      </Paragraph>
                    </a>
                  </div>
                </div>
                <div
                  style={{
                    borderBottom: "2px solid #707070",
                    padding: ".2rem 0",
                  }}
                />
                <br />

                <div className={classes.theFlexAction}></div>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Card className={classes.theCard}>
                      <TableContainer>
                        <Table>
                          <TableHead style={{ backgroundColor: "#1A5386" }}>
                            <TableRow>
                              <TableCell
                                style={{ borderRadius: "10px 0 0 10px" }}
                                className={classes.theHeadTitle}
                              >
                                Image
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Page
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Weight
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Title
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Subtitle
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ borderRadius: "0 10px 10px 0" }}
                                className={classes.theHeadTitle}
                              >
                                <MoreVert sx={{ color: "#fff" }} />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {listData != null &&
                              listData.map((item, index) => {
                                // if (searchKey != '') {
                                //   if (
                                //     item.postcode.indexOf(
                                //       searchKey.toUpperCase()
                                //     ) <= -1
                                //   ) {
                                //     return
                                //   }
                                // }
                                return (
                                  <TableRow>
                                    <a style={{ display: "contents" }}>
                                      <TableCell
                                        style={{
                                          textDecoration: "underline",
                                          background:
                                            index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <img
                                          style={{ width: "80px" }}
                                          src={item.image}
                                        />
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        {item.page}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        {item.weight}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        {item.title}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        {item.subtitle}
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          width: "10%",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <Button
                                          onClick={() => handleOpenEdit(item)}
                                          label="Edit"
                                          color="#fff"
                                          bg="#1A5386"
                                          size="12px"
                                          pd="10px"
                                          br="5px"
                                          style={{ marginBottom: "10px" }}
                                        />
                                        <Button
                                          onClick={() =>
                                            handleOpenDelete(item.banner_id)
                                          }
                                          label="Delete"
                                          color="#1A5386"
                                          bg="#fff"
                                          box="1px solid #1A5386"
                                          size="12px"
                                          pd="10px"
                                          br="5px"
                                        />
                                      </TableCell>
                                    </a>
                                  </TableRow>
                                );
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Card>
                    <br />
                    <br />
                  </Grid>
                </Grid>
                <br />
                <br />
              </div>

              <Dialog
                onClose={handleCloseAdd}
                open={openAdd}
                fullWidth="true"
                maxWidth="sm"
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Add Banner
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <input
                    className="ori-fileinput"
                    type="file"
                    name="file"
                    style={{
                      marginBottom: "1rem",
                    }}
                    onChange={handleCaptureSingle}
                  />

                  <FormInput
                    label="Page"
                    border="1px solid #c5c5c5"
                    br="6px"
                    onChange={handleChoosePage}
                    value={choosePage}
                    select
                  >
                    <MenuItem value="0">Please Choose a Page</MenuItem>
                    <MenuItem value="Home">Home</MenuItem>
                    <MenuItem value="About Us">About Us</MenuItem>
                    <MenuItem value="Ready to Wear">Ready to Wear</MenuItem>
                    <MenuItem value="Custom Made">Custom Made</MenuItem>
                    <MenuItem value="Decorative">Decorative</MenuItem>
                    <MenuItem value="Contact">Contact</MenuItem>
                  </FormInput>

                  {choosePage == "Home" && (
                    <FormInput
                      label="Weight*"
                      value={addData.weight}
                      textLabelColor="#000"
                      placeholder="Weight"
                      name="weight"
                      type="number"
                      border="1px solid #c5c5c5"
                      onChange={handleChangeAdd}
                    ></FormInput>
                  )}

                  {choosePage != "Home" && (
                    <>
                      {choosePage != 0 && (
                        <>
                          <FormInput
                            label="Title*"
                            value={addData.title}
                            textLabelColor="#000"
                            placeholder="Title"
                            name="title"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAdd}
                          />
                          <FormInput
                            label="Subtitle*"
                            value={addData.subtitle}
                            textLabelColor="#000"
                            placeholder="Subtitle"
                            name="subtitle"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAdd}
                          />
                        </>
                      )}
                    </>
                  )}

                  <br />
                  <Box>
                    {!disabled ? (
                      <Button
                        onClick={() => handleAddBanner()}
                        label="Add"
                        color="#fff"
                        bg="#1A5386"
                        size="18px"
                        pd="10px"
                        br="5px"
                        style={{ marginBottom: "10px" }}
                      />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "35px",
                        }}
                      >
                        <Loader
                          type="snipper-default"
                          bgColor={"#878787"}
                          size={30}
                        />
                      </div>
                    )}
                  </Box>
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseEdit}
                open={openEdit}
                fullWidth="true"
                maxWidth="sm"
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Edit Banner
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <input
                    className="ori-fileinput"
                    type="file"
                    name="file"
                    style={{
                      marginBottom: "1rem",
                    }}
                    onChange={handleCaptureSingle}
                  />

                  <FormInput
                    label="Page"
                    border="1px solid #c5c5c5"
                    br="6px"
                    onChange={handleChoosePage}
                    value={choosePage}
                    select
                  >
                    <MenuItem value="0">Please Choose a Page</MenuItem>
                    <MenuItem value="Home">Home</MenuItem>
                    <MenuItem value="About Us">About Us</MenuItem>
                    <MenuItem value="Ready to Wear">Ready to Wear</MenuItem>
                    <MenuItem value="Custom Made">Custom Made</MenuItem>
                    <MenuItem value="Decorative">Decorative</MenuItem>
                    <MenuItem value="Contact">Contact</MenuItem>
                  </FormInput>

                  {choosePage == "Home" && (
                    <FormInput
                      label="Weight*"
                      value={addData.weight}
                      textLabelColor="#000"
                      placeholder="Weight"
                      name="weight"
                      type="number"
                      border="1px solid #c5c5c5"
                      onChange={handleChangeAdd}
                    ></FormInput>
                  )}

                  {choosePage != "Home" && (
                    <>
                      {choosePage != 0 && (
                        <>
                          <FormInput
                            label="Title*"
                            value={addData.title}
                            textLabelColor="#000"
                            placeholder="Title"
                            name="title"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAdd}
                          />
                          <FormInput
                            label="Subtitle*"
                            value={addData.subtitle}
                            textLabelColor="#000"
                            placeholder="Subtitle"
                            name="subtitle"
                            border="1px solid #c5c5c5"
                            onChange={handleChangeAdd}
                          />
                        </>
                      )}
                    </>
                  )}

                  <br />

                  <Box>
                    {!disabled ? (
                      <Button
                        onClick={() => handleEditBanner()}
                        label="Save"
                        color="#fff"
                        bg="#1A5386"
                        size="18px"
                        pd="10px"
                        br="5px"
                        style={{ marginBottom: "10px" }}
                      />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "35px",
                        }}
                      >
                        <Loader
                          type="snipper-default"
                          bgColor={"#878787"}
                          size={30}
                        />
                      </div>
                    )}
                  </Box>
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseDelete}
                open={openDelete}
                fullWidth="true"
                maxWidth="sm"
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Delete Banner
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Paragraph
                    color="#000"
                    bold="600"
                    size="16px"
                    margin="0 0 1rem"
                  >
                    Are you sure to delete this banner?
                  </Paragraph>
                  <Button
                    onClick={() => handleDeleteBanner()}
                    label="Delete"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>
            </Section>
          }
        />
      )}
    </React.Fragment>
  );
}
